import Vue from 'vue'
import Router from 'vue-router'
import { eldRoutes, FullPageRoutes, logsRoutes, activityRoutes } from './modules'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // ============================ MAIN LAYOUT ROUTES ============================
      path: '',
      component: () => import('@/layouts/Main.vue'),
      children: [
        {
          path: '/',
          redirect: '/overview'
        },
        {
          path: '/overview',
          name: 'overview',
          component: () => import('@/views/overview/OverviewView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Overview', active: true }
            ],
            pageTitle: 'Overview',
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/driver/:id',
          name: 'drivers-info',
          component: () => import('@/views/overview/DriverDetailView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/overview' },
              { title: 'Drivers Info', active: true }
            ],
            pageTitle: 'Drivers Info',
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/company-profile',
          name: 'CompanySettings',
          component: () => import('@/views/company/CompanyProfileView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/overview' },
              { title: 'CompanySettings', active: true }
            ],
            pageTitle: 'CompanySettings',
            rule: 'editor',
            no_scroll: true
          }
        },
        // ================== SETTINGS PAGES ROUTES ====================
        {
          path: '/settings',
          name: 'Settings',
          component: () => import('@/views/settings/SettingsView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/overview' },
              { title: 'Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/reports',
          name: 'Reports',
          component: () => import('@/views/settings/ReportsView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/overview' },
              { title: 'Reports', active: true }
            ],
            pageTitle: 'Reports',
            rule: 'editor',
            no_scroll: true
          }
        },

      ]
    },
    // =========================== FULL PAGE LAYOUTS ===============================
    FullPageRoutes,
    // ======================= ELD SECTION PAGES ROUTES ==========================
    eldRoutes,
    // ======================= REPORTS SECTION PAGES ROUTES ==========================
    activityRoutes,
    // ======================= LOGS SECTION PAGES ROUTES ==========================
    logsRoutes,
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('access')
  if (authRequired && !loggedIn) {
    return next('/login')
  }
  // else if (!authRequired) {
  //   return next('/overview')
  // }
  next()
})

export default router
